const KEYS = {
  Firebase_API: "AIzaSyCnyFwM92x9cWqJNLwcLBhPhvp4lwOPfRU",
};

export default KEYS;
